<router-outlet></router-outlet>
<ngx-spinner></ngx-spinner>
<app-network-status></app-network-status>
